// Manual capacities and the owner's physical observations on 2026-10-08.
// A visible light sensor does not establish an alarm code or active detection.
const models={
 T11:{batteryMah:1100,magnets:false,lightSensor:'not-observed'},
 // Producer correction 2026-10-09 applies to the delivered T12 variant.
 T12:{batteryMah:3000,magnets:true,lightSensor:'absent'},
 D3:{batteryMah:5000,magnets:true,lightSensor:'observed'},
 'D3 Pro':{batteryMah:10000,magnets:true,lightSensor:'observed'},
};
export function yoguHardware(profile){return profile?.protocol==='gt06'&&Object.hasOwn(models,profile.model)?models[profile.model]:null;}
